import {
    List, ListItemButton, ListItemIcon, ListItemText, Checkbox, ListItem, ListItemAvatar, Avatar,
    Card, CardHeader, CardContent, TextField, FormControlLabel, InputAdornment, IconButton, Typography,
    Box,
    Select,
    MenuItem
} from "@mui/material";
import { NLCInfo } from "../data/interfaces/sharedmodels";
import { useAppDispatch, useAppSelector } from '../stores/hooks';
import { updateselectedNlcs as updateMagneticSelectedNlcs, updateselectedOutputNlcs as updateMagneticSelectedOutputNlcs } from '../stores/magneticslice';
import { updateselectedNlcs as updateItsoSelectedNlcs, updateselectedOutputNlcs as updateItsoSelectedOutputNlcs } from "../stores/itsoslice";
import { updateselectedNlcs as updateJobSelectedNlcs } from "../stores/jobsslice";
import { updateselectedNlcs as updateReportSelectedNlcs } from "../stores/reportslice";
import { Clear, Train as TrainIcon } from '@mui/icons-material';
import { useContext, useEffect, useState } from "react";
import commonService from "../data/api/common.service";
import { IsEditedContext } from "../../App";
import ConfirmDialog from "./confirmdialog";


export default function NLCList({ parent, disabled }: { parent: string, disabled: boolean }) {
    const dispatch = useAppDispatch();
    const [nlcs, setNlcs] = useState<NLCInfo[]>([]);
    const [allChecked, setAllChecked] = useState<boolean>(false);
    const [filterdNlcs, setFilteredNlcs] = useState<NLCInfo[]>([]);
    const [filterText, setFilterText] = useState<string>('');
    const [confirmDialogOpen, setConfirmDialogOpen] = useState<boolean>(false);
    const [pendingNlc, setPendingNlc] = useState<NLCInfo | null>(null);
    const [pendingAllChecked, setPendingAllChecked] = useState<boolean | null>(null); // Track pending 'Select All'
    const { isEdited, setIsEdited } = useContext(IsEditedContext);  // Context to check if form is edited
    const [sortByNlc,setSortByNlc]=useState<boolean>(false);
    const selectedTocs =
        useAppSelector((state) => {
            if (parent === 'reports_output') { return state.reportsReducer.selectedTocs; }
            else { return null };
        });
    const selectedNlcs = useAppSelector((state) => {
        if (parent === 'magnetic') { return state.magneticReducer.selectedNlcs; }
        else if (parent === 'magnetic_output') { return state.magneticReducer.selectedOutputNlcs; }
        else if (parent === 'itso_output') { return state.itsoReducer.selectedOutputNlcs; }
        else if (parent === 'create_job_output') { return state.jobsSliceReducer.selectedNlcs; }
        else if (parent === 'reports_output') { return state.reportsReducer.selectedNlcs; }
        else { return state.itsoReducer.selectedNlcs; }
    });
    const selectedTable = useAppSelector((state) => {
        if (parent === 'magnetic') { return state.magneticReducer.selectedDataTable; }
        else { return state.itsoReducer.selectedDataTable; }
    });

    useEffect(() => {
        loadNlcs();
        var sortbyNlcStorageItem=localStorage.getItem('NlcListSortByNlc');
        if(sortbyNlcStorageItem){
            setSortByNlc(sortbyNlcStorageItem=='1'?true:false);
        }
    }, []);

    useEffect(() => {
        if (selectedTocs)
            loadNlcs();
    }, [selectedTocs]);

    const loadNlcs = () => {
        commonService.getnlcs(selectedTocs).then((response) => {
            var sortbyNlcStorageItem=localStorage.getItem('NlcListSortByNlc');
            setNlcs(response.data.sort((a:NLCInfo, b:NLCInfo) => sortbyNlcStorageItem=='1' ? a.NLC.localeCompare(b.NLC) : a.StationName.localeCompare(b.StationName)));
        });
    }


    useEffect(() => {
        if (selectedTable && selectedTable.IsGlobal == false && selectedNlcs.length < 1) {
            if (parent === 'magnetic') { dispatch(updateMagneticSelectedNlcs([nlcs[0]])); }
            else { dispatch(updateItsoSelectedNlcs([nlcs[0]])); }

        }
    }, [selectedTable])

    useEffect(() => {
        setFilteredNlcs(nlcs);
        if (nlcs.length > 0) {

            if (parent === 'magnetic') {
                dispatch(updateMagneticSelectedNlcs([nlcs[0]]));
            }
            else if (parent === 'magnetic_output') { dispatch(updateMagneticSelectedOutputNlcs([nlcs[0]])); }
            else if (parent === 'itso_output') { dispatch(updateItsoSelectedOutputNlcs([nlcs[0]])); }
            else if (parent === 'create_job_output') { dispatch(updateJobSelectedNlcs([nlcs[0]])); }
            else if (parent === 'reports_output') { dispatch(updateReportSelectedNlcs([nlcs[0]])); }
            else {
                dispatch(updateItsoSelectedNlcs([nlcs[0]]))
            }
        }
    }, [nlcs])

    useEffect(() => {
        setAllChecked(nlcs.length > 0 && selectedNlcs.length === nlcs.length);

    }, [selectedNlcs]);

    useEffect(() => {
        let filternlcs = [...nlcs];
        if (filterText)
            filternlcs = [...nlcs].filter(a => a.StationName.toLowerCase().includes(filterText.toLowerCase()) ||
                a.NLC.toLowerCase().includes(filterText.toLowerCase()));
        setFilteredNlcs(filternlcs);
    }, [filterText])

    const handleAllChecked = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (isEdited) {
            setConfirmDialogOpen(true);
            setPendingAllChecked(event.target.checked); // Set pending 'Select All' action
        } else {
            selectAllNlcs(event.target.checked);
        }
    };

    const selectAllNlcs = (checked: boolean) => {
            if (parent === 'magnetic') {
                dispatch(updateMagneticSelectedNlcs(checked ? nlcs : []));
            }
            else if (parent === 'magnetic_output') { dispatch(updateMagneticSelectedOutputNlcs(checked ? nlcs : [])); }
            else if (parent === 'itso_output') { dispatch(updateItsoSelectedOutputNlcs(checked ? nlcs : [])); }
            else if (parent === 'create_job_output') { dispatch(updateJobSelectedNlcs(checked ? nlcs : [])); }
            else if (parent === 'reports_output') { dispatch(updateReportSelectedNlcs(checked ? nlcs : [])); }
            else {
                dispatch(updateItsoSelectedNlcs(checked ? nlcs : []))
            }
        
    };

    // const handleAllChecked = (
    //     event: React.ChangeEvent<HTMLInputElement>,
    // ) => {
    //     if (parent === 'magnetic') {
    //         dispatch(updateMagneticSelectedNlcs(event.target.checked ? nlcs : []));
    //     }
    //     else if (parent === 'magnetic_output') { dispatch(updateMagneticSelectedOutputNlcs(event.target.checked ? nlcs : [])); }
    //     else if (parent === 'itso_output') { dispatch(updateItsoSelectedOutputNlcs(event.target.checked ? nlcs : [])); }
    //     else if (parent === 'create_job_output') { dispatch(updateJobSelectedNlcs(event.target.checked ? nlcs : [])); }
    //     else if (parent === 'reports_output') { dispatch(updateReportSelectedNlcs(event.target.checked ? nlcs : [])); }
    //     else {
    //         dispatch(updateItsoSelectedNlcs(event.target.checked ? nlcs : []))
    //     }


    // };

    const handleToggle = (nlc: NLCInfo) => () => {
        if (isEdited) {
            setConfirmDialogOpen(true);
            setPendingNlc(nlc); // Set pending NLC to toggle after confirmation
        } else {
            toggleNlcSelection(nlc);
        }
    };

    const toggleNlcSelection = (nlc: NLCInfo) => {
        const currentIndex = selectedNlcs.findIndex(a => a.NLC == nlc.NLC);
        const newChecked = [...selectedNlcs];

        if (currentIndex === -1) {
            if (parent.indexOf('output') < 0)
                newChecked.splice(0, newChecked.length);
            newChecked.push(nlc);
        } else {
            newChecked.splice(currentIndex, 1);
        }

        if (parent === 'magnetic') {
            dispatch(updateMagneticSelectedNlcs(newChecked))
        }
        else if (parent === 'magnetic_output') { dispatch(updateMagneticSelectedOutputNlcs(newChecked)); }
        else if (parent === 'itso_output') { dispatch(updateItsoSelectedOutputNlcs(newChecked)); }
        else if (parent === 'create_job_output') { dispatch(updateJobSelectedNlcs(newChecked)); }
        else if (parent === 'reports_output') { dispatch(updateReportSelectedNlcs(newChecked)); }
        else {
            dispatch(updateItsoSelectedNlcs(newChecked))
        }
    };

    const handleDialogCallback = (confirmed: boolean) => {
        setConfirmDialogOpen(false);
        if (!confirmed) {
            setIsEdited(false);
            if (pendingNlc) {
                toggleNlcSelection(pendingNlc);
            }
            if (pendingAllChecked !== null) {
                selectAllNlcs(pendingAllChecked);
            }
        }
        setPendingNlc(null);
        setPendingAllChecked(null);
    };
    // const handleToggle = (nlc: NLCInfo) => () => {
    //     const currentIndex = selectedNlcs.findIndex(a => a.NLC == nlc.NLC);
    //     const newChecked = [...selectedNlcs];

    //     if (currentIndex === -1) {
    //         if (parent.indexOf('output') < 0)
    //             newChecked.splice(0, newChecked.length);
    //         newChecked.push(nlc);
    //     } else {
    //         newChecked.splice(currentIndex, 1);
    //     }

    //     if (parent === 'magnetic') {
    //         dispatch(updateMagneticSelectedNlcs(newChecked))
    //     }
    //     else if (parent === 'magnetic_output') { dispatch(updateMagneticSelectedOutputNlcs(newChecked)); }
    //     else if (parent === 'itso_output') { dispatch(updateItsoSelectedOutputNlcs(newChecked)); }
    //     else if (parent === 'create_job_output') { dispatch(updateJobSelectedNlcs(newChecked)); }
    //     else if (parent === 'reports_output') { dispatch(updateReportSelectedNlcs(newChecked)); }
    //     else {
    //         dispatch(updateItsoSelectedNlcs(newChecked))
    //     }
    // };

    const onFilterChnage = (
        event: React.ChangeEvent<HTMLInputElement>,
    ) => {
        setFilterText(event.target.value);

    };
    const clearFilter = () => {
        setFilterText('');
    }

    const handleSortByNlc=(sortByNlc:boolean)=>{
        localStorage.setItem('NlcListSortByNlc',sortByNlc?'1':'0');
        setSortByNlc(sortByNlc);
    }

    return (
        <Card>
            <ConfirmDialog
                isopen={confirmDialogOpen}
                title="Unsaved Changes"
                message="Are you sure you want to continue? Any unsaved changes will be lost."
                needComments={false}
                callback={handleDialogCallback}
                yesButtonText="Stay and Save"
                cancelButtonText="Continue"
            />
            <CardHeader title={
                <Box><Box sx={{ display: 'flex', mb: 1 }}>
                    <Avatar sx={{ backgroundColor: 'primary.main' }}>
                        <TrainIcon />
                    </Avatar>

                    <Typography variant="h6" sx={{ ml: 2 }}>Stations</Typography>
                </Box>

                    <TextField value={filterText} label="Filter Stations" size="small" sx={{ width: '100%' }} disabled={disabled} onChange={onFilterChnage}
                        InputProps={filterText ? {
                            endAdornment: (
                                <InputAdornment position="start">
                                    <IconButton onClick={clearFilter}>
                                        <Clear />
                                    </IconButton>

                                </InputAdornment>
                            ),
                        } : undefined} />
                       <FormControlLabel sx={{ width: '100%' }} control={<Checkbox size="small" onChange={(e)=>handleSortByNlc(e.target.checked)} checked={sortByNlc} value={sortByNlc} />} label="Sort by Nlc" />
                        
                        </Box>} />
            <CardContent sx={{ pt: 0, maxHeight: 850, overflowY: 'auto' }}>
                {disabled ? null : <Typography padding={1}>Select one {parent.indexOf('output') > -1 ? 'or more stations' : 'station'} to continue </Typography>}
                {parent.indexOf('output') > 0 ? <FormControlLabel sx={{ display: 'flex', justifyContent: 'start', ml: .5 }} labelPlacement="end"
                    control={<Checkbox disabled={disabled} checked={allChecked} onChange={handleAllChecked} />} label="Select All" /> : ''}
                <List disablePadding={true} dense={true}>
                    {
                        [...filterdNlcs].sort((a, b) => sortByNlc ? a.NLC.localeCompare(b.NLC) : a.StationName.localeCompare(b.StationName)).map(function (nlc) {
                            return (
                                <ListItem key={nlc.NLC}
                                    disablePadding>
                                    <ListItemButton onClick={handleToggle(nlc)} disabled={disabled}>
                                        <ListItemIcon>
                                            <Checkbox
                                                edge="start"
                                                disabled={disabled}
                                                checked={selectedNlcs.findIndex(a => a.NLC == nlc.NLC) > -1}
                                                tabIndex={-1}
                                                disableRipple
                                                onChange={handleToggle(nlc)}
                                                inputProps={{ 'aria-labelledby': nlc.StationName }}
                                            />
                                        </ListItemIcon>
                                        <ListItemText primary={nlc.NLC + ' - ' + nlc.StationName} />
                                    </ListItemButton></ListItem>)
                        })
                    }
                </List>
            </CardContent>
        </Card>
    );
}